import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import ReactDragList from 'react-drag-list';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
// TOOD: replace cloneDeep with ramda 
import cloneDeep from 'lodash/cloneDeep';
import formurlencoded from 'variables/urlencode';
import * as R from 'ramda';
import filesize from 'filesize.js';
import Upload from 'gcs-browser-upload';

import Api from 'services/api';
import { refreshToken, APIRoot } from 'variables/authentication.jsx';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  dragElement: {
    marginLeft: theme.spacing.unit,
    width: 200,
  },
  dense: {
    marginTop: 19,
  },
  menu: {
    width: 200,
  },
  nested: {
    minWidth: 200,
    maxWidth: 400 + 2 * theme.spacing.unit,
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    marginTop: theme.spacing.unit,
  },
  dragList: {
    marginTop: theme.spacing.unit,
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 300,
  },
  submit: {
    width: 200,
    height: 50,
    marginTop: 15,
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  delete: {
    marginRight: theme.spacing.unit,
  },
  listItemText: {
    fontSize: '1.0em',//Insert your required size
  }
});

const modes = {
  EDIT: 'edit',
  NEW: 'new',
  VIEW: 'view'
}

const deviceTypes = [
  {
    value: 'ios',
    label: 'IOS',
  },
  {
    value: 'android',
    label: 'ANDROID',
  },
];

class AddressablesForm extends React.Component {
  constructor(props) {
    super(props);
    this.switchMode = props.switchMode;
    this.getMode = props.getMode;
    this.handleCancel = this.handleCancel.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    const defaultData = {
      files: [],
      uploadStatuses: {}
    }
    this.state = {
      open: false,
      // TOOD: replace cloneDeep with ramda 
      data: props.getMode() == modes.EDIT ? cloneDeep(props.row_data) : defaultData
    };
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleChange = name => event => {
    var data = this.state.data;
    if (event.target.files) {
      const fileList = event.target.files; // FileList object not array
      const files = []
      for (let i = 0, ln = fileList.length; i < ln; i++) {
        files.push(fileList[i])
      }
      data[name] = files;
    } else {
      data[name] = event.target.value;
    }
    this.setState({ data: data });
  };

  handleAppend = event => {
    var data = this.state.data;
    this.setState({ data: data });
  }

  handleRemove = index => event => {
    var data = this.state.data;
    this.setState({ data: data });
  }

  handleCancel() {
    this.setState({ data: {} });
    this.switchMode(modes.VIEW);
  }

  async handleSubmit() {
    var data = this.state.data;

    try {
      // fix submit

      this.switchMode(modes.VIEW, true);
    } catch (e) {
      console.error(e)
    }

  }

  async handleDelete() {
    try {
      const { data: { id: addressableID } } = this.state;
      const deletedAddressable = await Api({
        endpoint: `/v4/addressables/${addressableID}`,
        method: 'DELETE',
      });

      this.switchMode(modes.VIEW, true);
    } catch (e) {
      console.error(e)
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <div >
        <form
          className={classes.container}
          noValidate
          autoComplete="off"
          style={{
            display: 'block'
          }}
        >
          <div
            style={{
              marginBottom: '1em'
            }}
          >
            <p>Select a addressables directory to upload:</p>
            <br/>
            <input
              directory=""
              webkitdirectory=""
              type="file"
              onChange={this.handleChange('files')}
            />
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Upload Status</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell align="right">Last Modified</TableCell>
                  <TableCell align="right">Size</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.data.files.map((row) => (
                  <TableRow key={row.name}>
                    <TableCell>
                      {this.state.data.uploadStatuses[row.name] || 'Pending Save'}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.name}
                    </TableCell>
                    <TableCell align="right">
                      {row.lastModifiedDate.toISOString}
                    </TableCell>
                    <TableCell align="right">
                      {filesize(row.size)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
          <div>
            <TextField
              id="engine_version"
              label="Engine Version"
              required
              value={this.state.data.engine_version}
              onChange={this.handleChange('engine_version')}
              type="text"
              className={classes.textField}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
            />
            <TextField
              id="device_type"
              select
              required
              label="Device Type"
              className={classes.textField}
              value={this.state.data.device_type}
              onChange={this.handleChange('device_type')}
              InputLabelProps={{
                shrink: true,
              }}
              SelectProps={{
                MenuProps: {
                  className: classes.menu,
                },
              }}
              margin="normal"
            >
              {deviceTypes.map(option => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              id="catalog-file"
              select
              required
              label="Catalog File"
              className={classes.textField}
              value={this.state.data.catalog_file}
              onChange={this.handleChange('catalog_file')}
              InputLabelProps={{
                shrink: true,
              }}
              SelectProps={{
                MenuProps: {
                  className: classes.menu,
                },
              }}
              margin="normal"
            >
              {this.state.data.files.map(file => (
                <MenuItem key={file.name} value={file.name}>
                  {file.name}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              id="hash-file"
              select
              required
              label="Hash File"
              className={classes.textField}
              value={this.state.data.hash_file}
              onChange={this.handleChange('hash_file')}
              InputLabelProps={{
                shrink: true,
              }}
              SelectProps={{
                MenuProps: {
                  className: classes.menu,
                },
              }}
              margin="normal"
            >
              {this.state.data.files.map(file => (
                <MenuItem key={file.name} value={file.name}>
                  {file.name}
                </MenuItem>
              ))}
            </TextField>
          </div>
        </form>

        <div>
          
        </div>
        <Button
          variant="contained"
          color="inherit"
          className={classes.submit}

          onClick={this.handleCancel}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          className={classes.submit}
          // // TODO: replace this with a ui warning or role based routing 
          // disabled={localStorage.getItem('role') != content_admin}
          onClick={this.handleSubmit}
        >
          Save
        </Button>
        <div>
          {this.props.getMode() == modes.EDIT ?
            <Button
              variant="text"
              color="secondary"
              className={classes.submit}
              // disabled={localStorage.getItem('role') != content_admin}
              onClick={this.handleClickOpen}>
              Delete
        </Button>
            :
            <></>}

          <Dialog
            open={this.state.open}
            onClose={this.handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Delete This Addressable?"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                You are about to delete addressable {} which cannot be undone.
            </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose} color="primary">
                Cancel
            </Button>
              <Button onClick={this.handleDelete} color="secondary" autoFocus>
                Delete
            </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
}

AddressablesForm.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AddressablesForm);